import * as yup from "yup";

export const staticLables = {
    header: "LiKES Intern Experience Survey - Internship Placement Matching Grant for SMEs and Start-Ups (LiKES) 2026",
    subHeader: "LiKES Intern Experience Survey",
    description: "Congratulations on completing your LiKES internship! Please complete this survey to help us improve the internship experience for future students.",
    section1: "Intern Personal Details",
    fullName: "Full Name",
    myKad: "IC Number",
    statelabel: "Please enter the state for each of the following:",
    insitutionState: "Institution State",
    hometownState: "Hometown State",
    companyState: "Company State",
    race: "Race",
    gender: "Gender",
    genderOption: [
        {
            value: "male",
            label: "Male"
        },
        {
            value: "female",
            label: "Female"
        }
    ],
    instiName: "Please indicate your institution name (including your campus/branch, if applicable)",
    academicQualification: "Intern Academic Qualification",
    academicOption: [
        {
            value: "master",
            label: "Master's Degree"
        },
        {
            value: "bachelor",
            label: "Bachelor's Degree"
        },
        {
            value: "certificate",
            label: "Certificate"
        },
        {
            value: "professional_cert",
            label: "Professional Certificate"
        },
        {
            value: "diploma",
            label: "Diploma"
        },
        {
            value: "dlkm",
            label: "Diploma Lanjutan Kemahiran Malaysia (DLKM)"
        },
        {
            value: "dkm",
            label: "Diploma Kemahiran Malaysia (DKM) "
        },
        {
            value: "certificate",
            label: "Certificate"
        },
        {
            value: "skm3",
            label: "Sijil Kemahiran Malaysia (SKM) Level 3"
        },
        {
            value: "skm2",
            label: "Sijil Kemahiran Malaysia (SKM) Level 2"
        },
        {
            value: "skm1",
            label: "Sijil Kemahiran Malaysia (SKM) Level 1"
        },
    ],
    fieldOfStudy: "Field of Study",
    fieldOfStudyOption: [
        {
            label: "Accounting / Finance / Banking / Insurance / Investment / Property",
            value: "accounting_finance_banking_insurance_investment_property",
        },
        {
            label: "Business / Management / HR",
            value: "business_management_hr",
        },
        {
            label: "Marketing / Sales / Advertising",
            value: "marketing_sales_advertising",
        },
        {
            label: "Economics",
            value: "economics",
        },
        {
            label: "Computer Science / IT / Software / Networks",
            value: "computer_science_it_software_networks",
        },
        {
            label: "Engineering",
            value: "engineering",
        },
        {
            label: "Architecture / Built Environment",
            value: "architecture_built_environment",
        },
        {
            label: "Science",
            value: "science",
        },
        {
            label: "Agriculture / Forestry / Fishery / Environment",
            value: "agriculture_forestry_fishery_environment",
        },
        {
            label: "Health & Medical",
            value: "health_medical",
        },
        {
            label: "Education",
            value: "education",
        },
        {
            label: "Arts / Social Science",
            value: "arts_social_science",
        },
        {
            label: "Design / Creative Media",
            value: "design_creative_media",
        },
        {
            label: "Journalism / Communications",
            value: "journalism_communications",
        },
        {
            label: "Psychology / Counselling",
            value: "psychology_counselling",
        },
        {
            label: "Languages",
            value: "languages",
        },
        {
            label: "International Relations / Diplomacy",
            value: "international_relations_diplomacy",
        },
        {
            label: "Law",
            value: "law",
        },
        {
            label: "TVET / Skilled Trades",
            value: "tvet_skilled_trades",
        },
        {
            label: "Tourism / Hospitality / Food & Beverage",
            value: "tourism_hospitality_food_beverage",
        },
        {
            label: "Transport / Transportation",
            value: "transport_transportation",
        },
        {
            label: "Sports / Sports Science",
            value: "sports_sports_science",
        },
        {
            label: "Other",
            value: "other",
        },
    ],
    section2: "Internship Details",
    companyName: "Company name",
    dates: "Please state your internship start and end dates",
    startdate: "Internship Start Date",
    enddate: "Internship End Date",
    section3: "Internship Experience & Challenges",
    whyCompany: "Why did you choose this company for your internship? (You may choose more than one)",
    whyOptions: [
        {
            value: "close-to-home",
            label: "Close to home / convenient location"
        },
        {
            value: "allowance",
            label: "Internship allowance provided"
        },
        {
            value: "jobscope",
            label: "Internship job scope is relevant and interesting"
        },
        {
            value: "good company",
            label: "Good company reputation"
        },
        {
            value: "flexible",
            label: "Flexible or manageable travel distance"
        },
        {
            value: "recommended",
            label: "Recommended by university / lecturer / peers"
        },
        {
            value: "other",
            label: "Other"
        }
    ],
    howManyApplication: "How many internship applications did you submit before receiving an offer?",
    howManyOption: [
        {
            value: ">15",
            label: "More than 15"
        },
        {
            value: "11-15",
            label: "11 to 15"
        },
        {
            value: "5-10",
            label: "5 to 10"
        },
        {
            value: "<5",
            label: "Less than 5"
        }
    ],
    interviews: "How many interviews did you attend before securing an internship placement?",
    interviewOption: [
        {
            value: ">10",
            label: "More than 10"
        },
        {
            value: "5-10",
            label: "5 to 10"
        },
        {
            value: "<5",
            label: "Less than 5"
        },
        {
            value: "0",
            label: "None"
        },
    ],
    platformLabel: "Which platform did you use to secure this internship placement offer? (You may choose more than one)",
    platforms: [
        {
            value: "mynext",
            label: "Mynext.my"
        },
        {
            value: "jobstreet",
            label: "Jobstreet"
        },
        {
            value: "monster",
            label: "Monster"
        },
        {
            value: "linkedin",
            label: "LinkedIn"
        },
        {
            value: "social",
            label: "Social media platform"
        },
        {
            value: "own",
            label: "Own network"
        },
        {
            value: "uni",
            label: "University connection"
        },
        {
            value: "other",
            label: "Other"
        }
    ],
    biggestConcern: "What were your biggest concerns when applying for an internship?",
    concerns: [
        {
            value: "The internship role is not related to my field of study",
            label: "The internship role is not related to my field of study"
        },
        {
            value: "Internship is unpaid or allowance is low",
            label: "Internship is unpaid or allowance is low"
        },
        {
            value: "Lack of internship opportunities / vacancies",
            label: "Lack of internship opportunities / vacancies"
        },
        {
            value: "Eligibility requirements (e.g. GPA, year of study)",
            label: "Eligibility requirements (e.g. GPA, year of study)"
        },
        {
            value: "Timing or duration of internship not suitable",
            label: "Timing or duration of internship not suitable"
        },
        {
            value: "The workplace location is not suitable",
            label: "The workplace location is not suitable"
        },
        {
            value: "Lack of required technical skills",
            label: "Lack of required technical skills"
        },
        {
            value: "Lack of communication or language skills",
            label: "Lack of communication or language skills"
        },
        {
            value: "Workplace environment concerns (e.g. bias, workplace culture)",
            label: "Workplace environment concerns (e.g. bias, workplace culture)"
        },
        {
            value: "other",
            label: "Other"
        }
    ],
    receiveOnboarding: "Did you receive an onboarding session for your internship?",
    onboardingOptions: [
        {
            value: "yes-1",
            label: "Yes, the induction briefing was provided by my university.",
        },
        {
            value: "yes-2",
            label: "Yes, the induction briefing was provided by my company.",
        },
        {
            value: "no",
            label: "No, an induction briefing was not provided.",
        },
    ],
    likesEasy: "Do your assigned duties match the job description?",
    typesOfDuty: "Types of work duties or tasks performed during the internship. (You may choose more than one)",
    duties: [
        {
            valeu: "Analytical / Problem-solving",
            label: "Analytical / Problem-solving"
        },
        {
            value: "Project-Based Tasks",
            label: "Project-Based Tasks"
        },
        {
            value: "Communication & Coordination",
            label: "Communication & Coordination"
        },
        {
            value: "Logistics",
            label: "Logistics"
        },
        {
            value: "Administration / Operational Support",
            label: "Administration / Operational Support"
        },
        {
            value: "Presentation & Reporting",
            label: "Presentation & Reporting"
        },
        {
            value: "Special Projects",
            label: "Special Projects"
        },
        {
            value: "Other",
            label: "Other"
        }
    ],
    receiveGuidance: "Did you receive guidance and support from your supervisor throughout the internship?",
    workOnProject: "Were you required to work on any projects and/or presentations during your internship?",
    scaleLabel: "Please enter the state for each of the following:",
    lineraScale: [
        {
            value: "technical_skills_rating",
            label: "Technical Skills"
        },
        {
            value: "soft_skills_rating",
            label: "Soft Skills (i.e. communication, problem-solving, adaptability, etc.)",
        },
        {
            value: "business_acumen_rating",
            label: "Business Acumen (i.e. presentation skills, sales skills, etc.)"
        },
        {
            value: "feedback_satisfaction_rating",
            label: "Your satisfaction with the feedback and coaching provided by your supervisor during your internship"
        },
        {
            value: "market_experience_rating",
            label: "Do you feel your internship experience has prepared you to enter the job market?"
        },
        {
            value: "overall_satisfaction_rating",
            label: "How satisfied are you with your overall internship experience?"
        }
    ],
    ratingOptions: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
        { value: 9, label: "9" },
        { value: 10, label: "10" }
    ],
    challengesFaced: "What challenges did you face during your internship? (You may choose up to 5 answers)",
    challenges: [
        {
            value: "Financial challenges (e.g. allowance, cost of living)",
            label: "Financial challenges (e.g. allowance, cost of living)"
        },
        {
            value: "Location or transportation challenges",
            label: "Location or transportation challenges"
        },
        {
            value: "Unclear job description or scope",
            label: "Unclear job description or scope"
        },
        {
            value: "Tasks not related to my field of study",
            label: "Tasks not related to my field of study"
        },
        {
            value: "Lack of guidance or feedback from supervisor",
            label: "Lack of guidance or feedback from supervisor"
        },
        {
            value: "Limited training or learning opportunities",
            label: "Limited training or learning opportunities"
        },
        {
            value: "Difficulty adapting to the work pace or environment",
            label: "Difficulty adapting to the work pace or environment"
        },
        {
            value: "Workplace environment issues (e.g. facilities, internet access)",
            label: "Workplace environment issues (e.g. facilities, internet access)"
        },
        {
            value: "Communication challenges (with supervisor or colleagues)",
            label: "Communication challenges (with supervisor or colleagues)"
        },
        {
            value: "other",
            label: "Other"
        },
    ],
    supportRequire: "In your opinion, choose the support you require to enhance your internship experience. (You may choose up to 5 answers)",
    supportOption: [
        {
            value: "Clear job description and expectations",
            label: "Clear job description and expectations"
        },
        {
            value: "Better work facilities or resources",
            label: "Better work facilities or resources"
        },
        {
            value: "Guidance from mentor / supervisor",
            label: "Guidance from mentor / supervisor"
        },
        {
            value: "Soft skills or professional skills training",
            label: "Soft skills or professional skills training"
        },
        {
            value: "Technical skills training",
            label: "Technical skills training"
        },
        {
            value: "Business acumen training (e.g. Microsoft Office, Excel, PowerPoint)",
            label: "Business acumen training (e.g. Microsoft Office, Excel, PowerPoint)"
        },
        {
            value: "Flexible working arrangements",
            label: "Flexible working arrangements"
        },
        {
            value: "Adequate allowance or financial support",
            label: "Adequate allowance or financial support"
        },
        {
            value: "other",
            label: "Other"
        },

    ],
    undergoInternship: "Would you consider undergoing an internship in a different field of study?",
    jobOffer: "Did you get a job offer after completing your internship at your current placement?",
    offerContract: "Type of job contract offer",
    industryOffered: "Please choose the industry of your job placement offer? (Please choose one)",
    industries: [
        {
            value: "Agriculture & Environment",
            label: "Agriculture & Environment"
        },
        {
            value: "Manufacturing & Industrial",
            label: "Manufacturing & Industrial"
        },
        {
            value: "Construction & Built Environment",
            label: "Construction & Built Environment"
        },
        {
            value: "Wholesale, Retail & Trade",
            label: "Wholesale, Retail & Trade"
        },
        {
            value: "Transportation & Logistics",
            label: "Transportation & Logistics"
        },
        {
            value: "Accommodation, Tourism & Food Services",
            label: "Accommodation, Tourism & Food Services"
        },
        {
            value: "Information & Communication (ICT / Media)",
            label: "Information & Communication (ICT / Media)"
        },
        {
            value: "Financial & Professional Services",
            label: "Financial & Professional Services"
        },
        {
            value: "Real Estate & Property",
            label: "Real Estate & Property"
        },
        {
            value: "Administrative & Support Services",
            label: "Administrative & Support Services"
        },
        {
            value: "Public Sector / Government",
            label: "Public Sector / Government"
        },
        {
            value: "Education",
            label: "Education"
        },
        {
            value: "Health & Social Services",
            label: "Health & Social Services"
        },
        {
            value: "Arts, Entertainment & Recreation",
            label: "Arts, Entertainment & Recreation"
        },
        {
            value: "Other Services",
            label: "Other Services"
        },
        {
            value: "Other",
            label: "Other"
        }
    ],
    improveOverall: "In your opinion, how can we improve the overall internship experience for students as a whole? We may use your feedback as a testimonial to be published for LiKES 2026.",
    termslabel: "Terms & Conditions*",
    termsCondition: "I understand that Talent Corporation Malaysia Berhad will collect, record, store, share and/or process my personal information, including but not limited to my contact details and other information relevant to my application for the programme. All personal information provided will be kept confidential and identifying information shall be replaced with a pseudonym for research purposes only."
}

export const initialStates = {
    institution_state: "",
    hometown_state: "",
    company_state: "",
    race: "",
    gender: "",
    institution_name: "",
    academic_qualification: "",
    field_of_study: "",
    field_of_study_other: "",
    company_name: "",
    internship_start_date: "",
    internship_end_date: "",
    why_choose_this_company: [],
    why_choose_this_company_other: "",
    applications_before_offered: "",
    interviews_attended: "",
    platform_used_to_secure_offer: [],
    platform_used_to_secure_offer_other: "",
    concerns_getting_hired: [],
    concerns_getting_hired_other: "",
    receive_onboarding: "",
    duties_match_job_description: "",
    types_of_work_duties: [],
    types_of_work_duties_other: "",
    receive_guidance: "",
    work_on_projects: null,
    technical_skills_rating: null,
    soft_skills_rating: null,
    business_acumen_rating: null,
    feedback_satisfaction_rating: null,
    market_experience_rating: null,
    overall_satisfaction_rating: null,
    challenges_faced: [],
    challenges_faced_other: "",
    support_required: [],
    support_required_other: "",
    consider_diff_fields_of_study: null,
    get_job_after_complete: "",
    type_of_job_contract_offer: "",
    offered_job_industry: "",
    offered_job_industry_other: "",
    overall_internship_experience: "",
}

// Fields that are always prefilled and permanently disabled on the form.
// They must always come from the API prefill, never from a locally saved draft.
export const PREFILL_LOCKED_FIELDS = [
    "hometown_state",
    "company_state",
    "race",
    "gender",
    "institution_name",
    "academic_qualification",
    "company_name",
    "internship_start_date",
    "internship_end_date",
];

export const pickDraftableFields = (values) => {
    if (!values || typeof values !== "object") return {};

    return Object.keys(values).reduce((acc, key) => {
        if (!PREFILL_LOCKED_FIELDS.includes(key)) {
            acc[key] = values[key];
        }

        return acc;
    }, {});
};


const MAX_OTHER_LENGTH = 300;
const MAX_COMMENT_LENGTH = 1000;
const MAX_CHECKBOX_SELECTION = 5;

const isOtherSelected = (value) => {
    if (Array.isArray(value)) {
        return value.includes("Other");
    }

    return value === "Other";
};

const requiredCheckbox = (message = "Please select at least one option") =>
    yup.array()
        .of(yup.string())
        .min(1, message)
        .required(message);

const maximumFiveCheckbox = yup.array()
    .of(yup.string())
    .min(1, "Please select at least one option")
    .max(
        MAX_CHECKBOX_SELECTION,
        "You may select a maximum of five (5) options only"
    )
    .required("Please select at least one option");

const conditionalOtherField = (dependentField) =>
    yup.string().when(dependentField, {
        is: (value) => isOtherSelected(value),
        then: (schema) =>
            schema
                .trim()
                .required("Please specify the details")
                .max(
                    MAX_OTHER_LENGTH,
                    `Must not exceed ${MAX_OTHER_LENGTH} characters`
                ),
        otherwise: (schema) => schema.notRequired().nullable(),
    });

const parseFormDate = (value) => {
    if (!value) return null;

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    if (typeof value !== "string") return null;

    const normalizedValue = value.trim();

    const yearFirstMatch = normalizedValue.match(
        /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/
    );

    if (yearFirstMatch) {
        const [, year, month, day] = yearFirstMatch;

        const parsedDate = new Date(
            Number(year),
            Number(month) - 1,
            Number(day)
        );

        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    const dayFirstMatch = normalizedValue.match(
        /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/
    );

    if (dayFirstMatch) {
        const [, day, month, year] = dayFirstMatch;

        const parsedDate = new Date(
            Number(year),
            Number(month) - 1,
            Number(day)
        );

        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    return null;
};

export const schema = yup.object({
    institution_state: yup.string()
        .required("Institution state is required"),

    hometown_state: yup.string()
        .required("Hometown state is required"),

    company_state: yup.string()
        .required("Company state is required"),

    race: yup.string()
        .required("Race is required"),

    gender: yup.string()
        .required("Gender is required"),

    institution_name: yup.string()
        .trim()
        .required("Institution name is required")
        .max(
            MAX_OTHER_LENGTH,
            `Must not exceed ${MAX_OTHER_LENGTH} characters.`
        ),

    field_of_study: yup.string()
        .trim()
        .required("Field of study required")
        .max(
            MAX_OTHER_LENGTH,
            `Must not exceed ${MAX_OTHER_LENGTH} characters.`
        ),
    
    field_of_study_other: yup
        .string()
        .when("field_of_study", {
            is: (value) => value === "Other",
            then: (schema) =>
                schema
                    .trim()
                    .required("Please specify your field of study")
                    .max(
                        MAX_OTHER_LENGTH,
                        `Must not exceed ${MAX_OTHER_LENGTH} characters`
                    ),
            otherwise: (schema) =>
                schema
                    .transform(() => "")
                    .notRequired(),
        }),
    academic_qualification: yup.string()
        .required("Academic qualification is required"),

    company_name: yup.string()
        .trim()
        .required("Company name is required")
        .max(
            MAX_OTHER_LENGTH,
            `Must not exceed ${MAX_OTHER_LENGTH} characters.`
        ),

    internship_start_date: yup.string()
        .required("Please select the Internship Start Date")
        .test(
            "valid-start-date",
            "Please select a valid Internship Start Date.",
            (value) => !value || Boolean(parseFormDate(value))
        ),

    internship_end_date: yup.string()
        .required("Please select the Internship End Date")
        .test(
            "valid-end-date",
            "Please select a valid Internship End Date.",
            (value) => !value || Boolean(parseFormDate(value))
        )
        .test(
            "end-date-after-start-date",
            "Internship End Date cannot be earlier than Internship Start Date",
            function (endDateValue) {
                const { internship_start_date } = this.parent;

                if (!endDateValue || !internship_start_date) {
                    return true;
                }

                const startDate = parseFormDate(internship_start_date);
                const endDate = parseFormDate(endDateValue);

                if (!startDate || !endDate) {
                    return true;
                }

                return endDate >= startDate;
            }
        ),
    why_choose_this_company: requiredCheckbox(),

    why_choose_this_company_other: conditionalOtherField(
        "why_choose_this_company"
    ),

    applications_before_offered: yup.string()
        .required("Please select an option"),

    interviews_attended: yup.string()
        .required("Please select an option"),

    platform_used_to_secure_offer: requiredCheckbox(),

    platform_used_to_secure_offer_other: conditionalOtherField(
        "platform_used_to_secure_offer"
    ),

    concerns_getting_hired: requiredCheckbox(),

    concerns_getting_hired_other: conditionalOtherField(
        "concerns_getting_hired"
    ),

    receive_onboarding: yup.string()
        .required("Please select an option"),

    // Replace this key if your field has a different name.
    duties_match_job_description: yup.string()
        .required("Please select an option"),

    types_of_work_duties: requiredCheckbox(),

    types_of_work_duties_other: conditionalOtherField(
        "types_of_work_duties"
    ),

    receive_guidance: yup.string()
        .required("Please select an option"),

    work_on_projects: yup.boolean()
        .typeError("Please select an option")
        .required("Please select an option"),

    technical_skills_rating: yup.number()
        .typeError("Please select a rating")
        .integer("Please select a valid rating")
        .min(1, "Rating must be between 1 and 10")
        .max(10, "Rating must be between 1 and 10")
        .required("Please select a rating"),

    soft_skills_rating: yup.number()
        .typeError("Please select a rating")
        .integer("Please select a valid rating")
        .min(1, "Rating must be between 1 and 10")
        .max(10, "Rating must be between 1 and 10")
        .required("Please select a rating"),

    business_acumen_rating: yup.number()
        .typeError("Please select a rating")
        .integer("Please select a valid rating")
        .min(1, "Rating must be between 1 and 10")
        .max(10, "Rating must be between 1 and 10")
        .required("Please select a rating"),

    feedback_satisfaction_rating: yup.number()
        .typeError("Please select a rating")
        .integer("Please select a valid rating")
        .min(1, "Rating must be between 1 and 10")
        .max(10, "Rating must be between 1 and 10")
        .required("Please select a rating"),

    market_experience_rating: yup.number()
        .typeError("Please select a rating")
        .integer("Please select a valid rating")
        .min(1, "Rating must be between 1 and 10")
        .max(10, "Rating must be between 1 and 10")
        .required("Please select a rating"),

    overall_satisfaction_rating: yup.number()
        .typeError("Please select a rating")
        .integer("Please select a valid rating")
        .min(1, "Rating must be between 1 and 10")
        .max(10, "Rating must be between 1 and 10")
        .required("Please select a rating"),

    // Internship Challenges
    challenges_faced: maximumFiveCheckbox,

    challenges_faced_other: conditionalOtherField("challenges_faced"),

    support_required: maximumFiveCheckbox,

    support_required_other: conditionalOtherField("support_required"),

    consider_diff_fields_of_study: yup.mixed()
        .required("Please select an option"),

    get_job_after_complete: yup.string()
        .required("Please select an option"),

    type_of_job_contract_offer: yup.string().when("get_job_after_complete", {
        is: (value) =>
            value === "Yes" ||
            value === "No, but received offer elsewhere",
        then: (schema) =>
            schema.required("Please select the type of job contract offered"),
        otherwise: (schema) => schema.notRequired().nullable(),
    }),

    offered_job_industry: yup.string().when("get_job_after_complete", {
        is: (value) =>
            value === "Yes" ||
            value === "No, but received offer elsewhere",
        then: (schema) =>
            schema.required("Please select the industry of the offered job"),
        otherwise: (schema) => schema.notRequired().nullable(),
    }),

    offered_job_industry_other: yup.string().when(
        ["get_job_after_complete", "offered_job_industry"],
        {
            is: (jobOfferReceived, industry) =>
                (jobOfferReceived === "Yes" ||
                    jobOfferReceived === "No, but received offer elsewhere") &&
                industry === "Other",
            then: (schema) =>
                schema
                    .trim()
                    .required("Please specify the details")
                    .max(
                        MAX_OTHER_LENGTH,
                        `Must not exceed ${MAX_OTHER_LENGTH} characters`
                    ),
            otherwise: (schema) => schema.notRequired().nullable(),
        }
    ),

    overall_internship_experience: yup.string()
        .trim()
        .required("Please complete this field")
        .max(
            MAX_COMMENT_LENGTH,
            `Must not exceed ${MAX_COMMENT_LENGTH} characters`
        ),
})

export const removeEmptyFields = (data) => {
    return Object.fromEntries(
        Object.entries(data).filter(([_, value]) => {
            if (value === null || value === undefined || value === "") {
                return false;
            }

            if (Array.isArray(value) && value.length === 0) {
                return false;
            }

            return true;
        })
    );
};